/** Simulator app routes (sidebar + deep links). */
export const SIMULATOR_LIST_PATH = "/simulator";
export const SIMULATOR_NEW_PATH = "/simulator/new";
export const SIMULATOR_RESULTS_PATH = "/simulator/results";

export const LEGACY_SIMULATOR_BASE_PATH = "/execution-rules-simulator";

export function simulatorRunDetailPath(backtestId: string): string {
  return `/simulator/runs/${encodeURIComponent(backtestId)}`;
}

export function simulatorResultsWithBacktestPath(backtestId: string): string {
  return `${SIMULATOR_RESULTS_PATH}?backtest=${encodeURIComponent(backtestId)}`;
}

export function simulatorResultsWithRunPath(runId: string): string {
  return `${SIMULATOR_RESULTS_PATH}?run=${encodeURIComponent(runId)}`;
}
